const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  list: [],
  currentTicket: null,
  comments: [],
  filter: {
    page: 1,
    size: 10,
  },
  totalItems: 0,
};

const supportSlice = createSlice({
  name: "support",
  initialState,
  reducers: {
    setSupportTicketList: (state, action) => {
      state.list = action.payload;
    },
    setSupportCurrentTicket: (state, action) => {
      state.currentTicket = action.payload;
    },
    setSupportTicketComments: (state, action) => {
      state.comments = action.payload;
    },
    setSupportTotalItems: (state, action) => {
      state.totalItems = action.payload;
    },
    setSupportPage: (state, action) => {
      state.filter.page = action.payload;
    },
    setSupportListSize: (state, action) => {
      state.filter.size = action.payload;
    },
  },
});

const { actions } = supportSlice;

export const {
  setSupportTicketList,
  setSupportCurrentTicket,
  setSupportTicketComments,
  setSupportTotalItems,
  setSupportPage,
  setSupportListSize,
} = actions;

export const selSupportTicketList = (state) => state.support.list;
export const selSupportCurrentTicket = (state) => state.support.currentTicket;
export const selSupportTicketComments = (state) => state.support.comments;
export const selSupportTotalItems = (state) => state.support.totalItems;
export const selSupportPage = (state) => state.support.filter.page;
export const selSupportListSize = (state) => state.support.filter.size;

const reducer = {
  support: supportSlice.reducer,
};

export default reducer;
